import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id A965D069-BF40-4F96-B64D-6C1C93F0E2E3
 * name hexagram
 * version: 2.7.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hexagram.svg
 * tags
 * - Shape 
 * - Holiday 
 */
export const HexagramIcon = createSvgIcon(<><path d="M14.5,7.66L20.64,6.97L17,12L20.68,16.97L14.5,16.32L12.03,22L9.5,16.34L3.36,17.03L7,12L3.32,7.03L9.5,7.68L11.97,2L14.5,7.66Z" /></>, 'HexagramIcon');
export default HexagramIcon